var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMessageCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/message_check") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uD83D\\uDC99-Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-48, -671)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Message-Check",
    transform: "translate(48, 671)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Base",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9797531,5.14857013 L6.04511558,16.2683539 L2.02732928,12.1825381 C1.83253407,11.9844446 1.51668814,11.9844446 1.32185136,12.1825381 L0.146096407,13.378201 C-0.0486988025,13.5762945 -0.0486988025,13.8974884 0.146096407,14.0956242 L5.69235584,19.7357934 C5.88715105,19.9338869 6.20299698,19.9338869 6.39783376,19.7357934 L18.8609444,7.06165621 C19.0557396,6.86356271 19.0557396,6.54236885 18.8609444,6.34423307 L17.6851894,5.14857013 C17.4903942,4.95047662 17.1745483,4.95047662 16.9797531,5.14857013 Z",
    id: "Icon",
    fill: "#191C24"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMessageCheck);
export default __webpack_public_path__ + "static/media/message_check.cdef1ed9.svg";
export { ForwardRef as ReactComponent };